package co.laiautomation

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import co.laiautomation.downtyme.DowntymeRootComponent
import co.laiautomation.downtyme.downtymeConfig
import com.arkivanov.decompose.DefaultComponentContext
import com.arkivanov.essenty.lifecycle.LifecycleRegistry
import com.arkivanov.essenty.lifecycle.resume
import com.laiautomation.kdxp.appmodel.KdxpTargetPlatform

internal expect val currentWebTarget: KdxpTargetPlatform

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val lifecycle = LifecycleRegistry().apply { resume() }
    val root = DowntymeRootComponent(
        componentContext = DefaultComponentContext(lifecycle = lifecycle),
        targetPlatform = currentWebTarget,
        config = downtymeConfig(),
    )
    ComposeViewport { App(root) }
}
